<template>
  <div :class="wrapperClasses" class="d-flex justify-content-end">
    <b-button
      v-if="havePermissionToEdit"
      variant="secondary"
      size="sm"
      class="px-1 text-dark bg-transparent border-0 text-uppercase"
      @click.stop.prevent="callEditItem"
    >
      <font-awesome-icon :icon="icon.edit" size="lg" />
    </b-button>
    <click-confirm
      v-if="havePermissionToRemove"
      class="btn btn-secondary text-dark bg-transparent border-0 btn-sm px-1 ml-1 text-uppercase"
      :messages="confirmationMessages"
      yes-class="btn btn-success"
      no-class="btn btn-danger"
    >
      <template slot="confirm-yes-icon">
        <font-awesome-icon :icon="icon.thumbsUp" fixed-width />
      </template>
      <template slot="confirm-no-icon">
        <font-awesome-icon :icon="icon.thumbsDown" fixed-width />
      </template>

      <div @click.stop="callRemoveItem">
        <font-awesome-icon :icon="icon.trash" fixed-width size="lg" />
      </div>
    </click-confirm>
  </div>
</template>

<script>
import ClickConfirm from 'click-confirm'
import {
  faEdit,
  faTrashAlt,
  faThumbsUp,
  faThumbsDown,
  faListAlt
} from '@fortawesome/free-regular-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  components: {
    FontAwesomeIcon,
    ClickConfirm
  },
  props: {
    id: {
      type: Number,
      required: true
    },
    theme: {
      type: String,
      required: false,
      default: null
    },
    wrapperClasses: {
      type: String,
      required: false,
      default: null
    },
    havePermissionToRemove: {
      type: Boolean,
      required: false,
      default: true
    },
    havePermissionToEdit: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: () => ({
    icon: {
      edit: faEdit,
      trash: faTrashAlt,
      thumbsUp: faThumbsUp,
      thumbsDown: faThumbsDown,
      order: faListAlt
    }
  }),
  computed: {
    confirmationMessages() {
      return {
        title: this.$t('confirm.are_you_sure'),
        yes: this.$t('confirm.yes'),
        no: this.$t('confirm.no')
      }
    }
  },
  methods: {
    callEditItem() {
      this.$emit('editItem', this.id)
    },
    callRemoveItem() {
      this.$emit('removeItem', this.id)
    }
  }
}
</script>
